export const state = () => ({
  site: {

  }
})

export const mutations = {
  setSiteData (state,data) {
    state.site = data;
  }
}

export const actions = {
  // nuxtServerInit is called by Nuxt.js before server-rendering every page
  async nuxtServerInit ({commit, dispatch, rootState}, {store, route, app,redirect}) {

    await dispatch('user/fetchSession', { $axios: app.$axios, eventId: null});
    if (rootState?.user?.session.uid !== undefined &&  rootState.user.session.uid !== null &&
      (route.path === '/editor/appystudio' ||
      route.path === '/editor/appystudio/' ||
      route.path === '/editor/appystudio/welcome' ||
      route.path === '/editor/appystudio/welcome/' ||
      route.path === '/editor/appystudio/welcome/select/' ||
      route.path === '/editor/appystudio/welcome/select' ||
      route.path === '/editor/appystudio/emailpreview/' ||
      route.path === '/editor/appystudio/emailpreview'
      //  || route.path === '/digitalinvites/'
      // || route.path === '/digitalinvites'
    )
    ) {
      await dispatch('user/fetchProfile', { $axios: app.$axios});
    }
  }
}
